// extracted by mini-css-extract-plugin
export default {"filterChip":"FilterChips_filterChip__RD8nJ","closeIcon":"FilterChips_closeIcon__Olqn+"};